import React from 'react';
import moment from 'moment-timezone';

import Select from '../../common/Select';
import DateRangePicker from '../../DateRangePicker';
import { DAY_BEGIN, FULL_DATE_FORMAT } from '../../../constants/date';

const QUERY_RANGE = "Query's range";
const CUSTOM_RANGE = 'Custom range';

const getTrailingMonthRange = (zoneId) => [
  moment().tz(zoneId).set(DAY_BEGIN).subtract(1, 'month').format(FULL_DATE_FORMAT),
  moment().tz(zoneId).set(DAY_BEGIN).add(1, 'days').format(FULL_DATE_FORMAT),
];

const CompoundUpdateDateRangePicker = ({ onChange, value, zoneId }) => (
  <div
    style={{
      display: 'flex',
      flexDirection: 'row',
      alignItems: 'center',
      justifyContent: 'flex-start',
      marginTop: 10,
    }}
  >
    <div className="disable-select" style={{ whiteSpace: 'nowrap', marginRight: 10 }}>
      Date Range:
    </div>
    <Select
      allowClear={false}
      values={[QUERY_RANGE, CUSTOM_RANGE]}
      value={value ? CUSTOM_RANGE : QUERY_RANGE}
      onChange={(v) =>
        v === CUSTOM_RANGE ? onChange(...getTrailingMonthRange(zoneId)) : onChange(null)
      }
    />
    {value && (
      <div style={{ marginLeft: 10 }}>
        <DateRangePicker zoneId={zoneId} from={value.from} to={value.to} onChangeRange={onChange} />
      </div>
    )}
  </div>
);

export default CompoundUpdateDateRangePicker;
